import { Menu, Info, MessageSquarePlus } from 'lucide-react';
import { useState } from 'react';
import { useAppDispatch } from '@/store';
import { startNewChat } from './messageSlice';
import { toggleSidebar } from '@/chats/chatSlice';
import AlertModal from './DataDefinition';

export default function MainHeader() {
  const dispatch = useAppDispatch();
  const [isModalOpen, setOpen] = useState(false);

  return (
    <header className="h-16 flex items-center gap-2 p-4 bg-blue-600 border-b border-blue-700 shadow-md shrink-0">
      <div className="relative mx-auto w-full p-3 flex items-center">
        <div className="flex gap-4">
          <Menu size={24} className="text-white hover:text-blue-400" onClick={() => dispatch(toggleSidebar())} />
          <img src="/logo.svg" className="h-8 w-8" alt="SM AI Logo" />
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2">
          <h1 className="text-lg font-bold text-white"><span className="text-black">SM AI:</span> SAMI</h1>
        </div>
        <div className="ml-auto flex items-center gap-4">
          <MessageSquarePlus size={24} className="text-white hover:text-blue-400" onClick={() => dispatch(startNewChat())}/>
          <Info size={24} className="text-white hover:text-blue-400" onClick={() => setOpen(true)} />
        </div>
        <AlertModal isOpen={isModalOpen} onClose={() => setOpen(false)} />
      </div>
    </header>
  );
}
